import { Button, Dropdown } from "antd";
import { Download, ChevronDown } from "lucide-react";

export default function SalesExportButton({ onExport, isExporting, disabled }) {
  const items = [
    { key: "csv", label: "Export as CSV" },
    { key: "excel", label: "Export as Excel" },
  ];

  return (
    <Dropdown
      menu={{
        items,
        onClick: ({ key }) => onExport(key),
      }}
      disabled={disabled || isExporting}
      trigger={["click"]}
    >
      <Button
        type="primary"
        loading={isExporting}
        disabled={disabled}
        className="!flex !items-center !gap-1.5 !h-8"
        icon={<Download size={14} />}
      >
        Export
        <ChevronDown size={14} />
      </Button>
    </Dropdown>
  );
}
